import React from 'react';
import {useTitleTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import styles from '@dazn/lp-web/src/components/SupportedDevices/supportedDevices.module.css';
import Markdown from 'markdown-to-jsx';
import {animated} from '@react-spring/web';
import {IBenefit} from '@dazn/lp-web/src/types/benefits.types';
import { applyGoldColor } from '../ContentTiers/ContentTiers';

interface IProps {
    data: any;
    key: number;
    disableAnimation: boolean;
}

const SupportedDevices: React.FC<IProps> = ({data, disableAnimation}) => {
    const [refView, springs] = useTitleTransitions();
    const {
        devices,
        title,
        description,
        supportDeviceHeader,
        supportedDeviceFooter
    } = data;

    const animations = disableAnimation
        ? {}
        : {
              style: springs,
              ref: refView
          };

    return (
        <div className={styles.supportedDevicesContainer}>
            <animated.div {...animations} className={styles.contentContainer}>
                <Markdown className={styles.devicesTitle}>
                    {applyGoldColor(title)}
                </Markdown>
                <Markdown className={styles.devicesDescription}>
                    {description}
                </Markdown>

                {supportDeviceHeader && (
                    <div className={styles.supportedDeviceDivider}>
                        <div className={styles.line}></div>
                        <div className={styles.supportDeviceHeader}>
                            <Markdown>{supportDeviceHeader}</Markdown>
                        </div>
                        <div className={styles.line}></div>
                    </div>
                )}
                <div className={styles.logoContainer}>
                    {devices?.map(
                        (
                            device: IBenefit,
                            index: React.Key | null | undefined
                        ) => (
                            <img
                                src={device?.logo?.src}
                                alt={device?.title ?? 'device-logo'}
                                className={styles.logo}
                                key={index}
                            />
                        )
                    )}
                </div>

                {supportedDeviceFooter && (
                    <div className={styles.supportedDeviceDisclaimer}>
                        <Markdown>{supportedDeviceFooter}</Markdown>
                    </div>
                )}
            </animated.div>
        </div>
    );
};

export default SupportedDevices;
